import { TelecomInterest } from '@app/tots/tots-wizard.constants';
import { SelectInput, Svg } from '@smooved/ui';

const telecomInterestMap = [
    { value: TelecomInterest.Interested, svg: Svg.Telecom, label: 'TELECOM.INTEREST.OPTIONS.INTERESTED' },
    { value: TelecomInterest.Unknown, svg: Svg.Unknown, label: 'TELECOM.INTEREST.OPTIONS.UNKNOWN' },
    { value: TelecomInterest.NotInterested, svg: Svg.Client, label: 'TELECOM.INTEREST.OPTIONS.NOT_INTERESTED' },
];

export const telecomInterestOptions: SelectInput<TelecomInterest>[] = [
    ...telecomInterestMap.map<SelectInput<TelecomInterest>>((item) => ({
        id: 'telecom-interested',
        name: `Telecom-interested-${item.value}`,
        value: item.value,
        labelResource: item.label,
        svg: item.svg,
    })),
];
